import { motion } from "framer-motion";
import { X } from "lucide-react";

export default function AboutPanel({ onClose }) {
  return (
    <>
      <motion.div
        className="fixed inset-0 z-[64] bg-black/60"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        onClick={onClose}
      />
      <motion.div
        data-testid="about-panel"
        className="fixed inset-0 z-[65] flex items-center justify-center px-5 pointer-events-none"
      >
        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.99 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="pointer-events-auto grain relative max-w-2xl w-full max-h-[84dvh] overflow-y-auto archival-scroll px-8 sm:px-14 py-12"
          style={{
            background: "#161310",
            border: "1px solid rgba(197,160,89,0.22)",
            boxShadow: "0 50px 140px rgba(0,0,0,0.8)",
          }}
        >
          <button
            data-testid="about-close"
            onClick={onClose}
            aria-label="Close about"
            className="absolute top-5 right-5 text-[#857565] hover:text-[#C5A059] transition-colors duration-500"
          >
            <X size={18} strokeWidth={1.25} />
          </button>

          <p className="font-nav text-[9px] tracking-[0.5em] uppercase text-[#857565] text-center">
            Provenance
          </p>
          <h2 className="font-display text-3xl sm:text-4xl tracking-[0.1em] uppercase text-[#E8DCC4] text-center mt-3">
            About This Work
          </h2>

          <div className="ornament my-8">
            <span className="diamond" />
          </div>

          <div className="font-serif-body text-[#B8A795] text-base sm:text-lg leading-relaxed space-y-5 text-center">
            <p className="font-nav text-[10px] tracking-[0.45em] uppercase text-[#C5A059]">
              Confidential &amp; Proprietary
            </p>
            <p>
              This presentation contains private, confidential, and proprietary information
              intended solely for authorized recipients.
            </p>
            <p>
              The concepts, plans, visuals, research, and supporting materials contained in this
              presentation are provided for private review only.
            </p>
            <p>
              No part of this material may be copied, reproduced, forwarded, published,
              distributed, disclosed, or shared with any third party without prior authorization.
            </p>
          </div>

          <div className="ornament my-8">
            <span className="diamond" />
          </div>

          <p className="font-serif-body text-[#B8A795] text-base sm:text-lg leading-relaxed text-center">
            Miniature India Park is envisioned as a single, living representation of Bharat —
            one nation held within one artwork. Each region of the master plan opens into its
            own illustrated world, and each world returns you to the whole.
          </p>

          <div className="ornament my-8">
            <span className="diamond" />
          </div>

          <p className="font-nav text-[10px] tracking-[0.45em] uppercase text-[#857565] text-center">
            Private Presentation
          </p>
          <p className="font-nav text-[10px] tracking-[0.25em] text-[#C5A059] text-center mt-2 mb-8">
            RajGoyal.com
          </p>

          <div className="text-center">
            <a
              data-testid="about-titanium-link"
              href="https://titaniumwealthusa.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block font-nav text-[10px] tracking-[0.3em] uppercase text-[#C5A059] border border-[rgba(197,160,89,0.3)] px-6 py-3 hover:border-[rgba(197,160,89,0.65)] hover:bg-[rgba(197,160,89,0.06)] transition-all duration-500"
            >
              TitaniumWealthUSA.com
            </a>
          </div>
        </motion.div>
      </motion.div>
    </>
  );
}
